import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const CheckpointActions = {
    checkin: 'in',
    checkout: 'out',
    sick: 'sick',
    excused: 'excused',
    vacation: 'vacation',
    unknown: 'unknown'
};
export const CheckpointAction = Type.Union([
    Type.Literal(CheckpointActions.checkin),
    Type.Literal(CheckpointActions.checkout),
    Type.Literal(CheckpointActions.sick),
    Type.Literal(CheckpointActions.excused),
    Type.Literal(CheckpointActions.vacation),
    Type.Literal(CheckpointActions.unknown)
]);
export const CheckpointActionCodec = createFallbackStringEnumCodec(CheckpointActions, CheckpointActions.unknown);
export const NameToFaceCheck = Type.Object({
    id: Type.String({ minLength: 1 }),
    time: Type.Number(),
    classKey: Type.Optional(Type.String({ minLength: 1 })),
    actor: Type.Optional(Type.String({ minLength: 1 })),
    actorKey: Type.Optional(Type.String({ minLength: 1 })),
    exception: Type.Optional(Type.String({ minLength: 1 }))
});
export const ClassroomTransitionTypes = {
    move: 'm',
    visit: 'v',
    returning: 'r',
    unknown: 'unknown'
};
export const ClassroomTransitionType = Type.Union([
    Type.Literal(ClassroomTransitionTypes.move),
    Type.Literal(ClassroomTransitionTypes.visit),
    Type.Literal(ClassroomTransitionTypes.returning),
    Type.Literal(ClassroomTransitionTypes.unknown)
]);
export const ClassroomTransitionTypeCodec = createFallbackStringEnumCodec(ClassroomTransitionTypes, ClassroomTransitionTypes.unknown);
export const ClassroomTransition = Type.Object({
    id: Type.String({ minLength: 1 }),
    fromClassKey: Type.Optional(Type.String({ minLength: 1 })),
    toClassKey: Type.Optional(Type.String({ minLength: 1 })),
    transitionTimestamp: Type.Number(),
    transitionType: ClassroomTransitionTypeCodec
});
export const Checkpoint = Type.Object({
    key: Type.String({ minLength: 1 }),
    deleted: Type.Optional(Type.Boolean()),
    memberKey: Type.String({ minLength: 1 }),
    locationKey: Type.Optional(Type.String({ minLength: 1 })),
    groupKey: Type.Optional(Type.String({ minLength: 1 })),
    initialHomeroomKey: Type.Optional(Type.String({ minLength: 1 })),
    action: CheckpointActionCodec,
    cut: Type.Number(),
    ut: Type.Number(),
    actionTime: Type.Number(),
    inTimestamp: Type.Optional(Type.Number()),
    outTimestamp: Type.Optional(Type.Number()),
    accidentalCheckoutTimestamp: Type.Optional(Type.Number()),
    note: Type.Optional(Type.String({ minLength: 1 })),
    excused: Type.Optional(Type.Boolean()),
    inGuardianKey: Type.Optional(Type.String({ minLength: 1 })),
    outGuardianKey: Type.Optional(Type.String({ minLength: 1 })),
    inGuardianName: Type.Optional(Type.String({ minLength: 1 })),
    outGuardianName: Type.Optional(Type.String({ minLength: 1 })),
    isScheduled: Type.Optional(Type.Boolean()),
    n2fChecks: Type.Optional(Type.Array(NameToFaceCheck)),
    visitHistory: Type.Optional(Type.Array(ClassroomTransition))
});
